import { PublicCertification } from '@wix/ambassador-academy-certifications-v1-account-certification/types';
import { Box } from '@wix/design-system';
import React from 'react';
import LabeledCertification from './CertificationDisplay/LabeledCertification';

interface CertificationsGridProps {
  certifications: PublicCertification[];
  isMobileView?: boolean;
}

const CertificationsGrid: React.FC<CertificationsGridProps> = ({
  certifications,
  isMobileView,
}) => {
  return (
    <Box direction={isMobileView ? 'vertical' : 'horizontal'} gap="24px">
      {certifications.map((cert) => (
        <LabeledCertification
          key={cert.certificationType}
          cert={cert}
          isMobile={isMobileView}
        />
      ))}
    </Box>
  );
};

export default CertificationsGrid;
